/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import {VStack} from 'native-base';
import {StyleSheet} from 'react-native';

import {NativeStackScreenProps} from '@react-navigation/native-stack';
import InternalTemplate from '../../../templates/internal';
import {StackParamList} from '../../../../navigators';
import {PrimaryButton} from '../../../buttons';

type ScreenProps = NativeStackScreenProps<StackParamList, 'MapModalScreen'>;

const MapModalScreen = ({navigation}: ScreenProps) => {
  const handleGoBack = () => {
    navigation.pop(1);
  };

  const onAcceptButton = () => {};

  return (
    <InternalTemplate
      title={'salesman-order-add-title'}
      contentPaddingX="3"
      childContainerStyle={styles.childContainerStyle}
      backButton={{
        onPress: () => handleGoBack(),
        label: 'go-back',
        usage: 'external',
      }}>
      <VStack marginX={10}>
        <PrimaryButton
          label="map-modal-accept-button-label"
          onPress={() => onAcceptButton()}
        />
      </VStack>
    </InternalTemplate>
  );
};
export default MapModalScreen;

const styles = StyleSheet.create({
  childContainerStyle: {
    display: 'flex',
    flex: 1,
    paddingBottom: 15,
  },
  mapContainer: {
    flex: 1,
  },
  map: {
    flex: 1,
    height: '100%',
  },
});
